"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowPropertyDescriptor = void 0;
var table_row_descriptors_1 = require("./table-row-descriptors");
var TableRowPropertyDescriptor = (function () {
    function TableRowPropertyDescriptor() {
    }
    TableRowPropertyDescriptor.cantSplit = new table_row_descriptors_1.TableRowPropertiesCantSplitDescriptor();
    TableRowPropertyDescriptor.cellSpacing = new table_row_descriptors_1.TableRowPropertiesCellSpacingDescriptor();
    TableRowPropertyDescriptor.divId = new table_row_descriptors_1.TableRowPropertiesDivIdDescriptor();
    TableRowPropertyDescriptor.header = new table_row_descriptors_1.TableRowPropertiesHeaderDescriptor();
    TableRowPropertyDescriptor.hideCellMark = new table_row_descriptors_1.TableRowPropertiesHideCellMarkDescriptor();
    TableRowPropertyDescriptor.rowAlignment = new table_row_descriptors_1.TableRowPropertiesRowAlignmentDescriptor();
    TableRowPropertyDescriptor.ALL_FIELDS = [
        TableRowPropertyDescriptor.cantSplit,
        TableRowPropertyDescriptor.cellSpacing,
        TableRowPropertyDescriptor.divId,
        TableRowPropertyDescriptor.header,
        TableRowPropertyDescriptor.hideCellMark,
        TableRowPropertyDescriptor.rowAlignment,
    ];
    return TableRowPropertyDescriptor;
}());
exports.TableRowPropertyDescriptor = TableRowPropertyDescriptor;
